<template>
  <el-dialog
    :title="$t('allocationOrder.auditInfo')"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item :label="$t('allocationOrder.auditStatus')" prop="state" required>
        <el-select
          v-model="formData.state"
          :placeholder="$t('allocationOrder.selectAuditStatus')"
          style="width:100%"
          @change="handleStatusChange"
        >
          <el-option
            :label="$t('allocationOrder.agree')"
            value="2002"
          />
          <el-option
            :label="$t('allocationOrder.reject')"
            value="3003"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('allocationOrder.reason')" prop="remark" required>
        <el-input
          v-model="formData.remark"
          type="textarea"
          :rows="3"
          :placeholder="$t('allocationOrder.inputReason')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('common.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'AllocationOrderAudit',
  props: {
    callBackListener: {
      type: String,
      default: ''
    },
    callBackFunction: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        state: '',
        remark: ''
      }
    }
  },
  methods: {
    open() {
      this.resetForm()
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    },
    resetForm() {
      this.formData = {
        state: '',
        remark: ''
      }
    },
    handleStatusChange(val) {
      if (val === '2002') {
        this.formData.remark = this.$t('allocationOrder.agree')
      } else {
        this.formData.remark = ''
      }
    },
    validateForm() {
      if (!this.formData.state) {
        this.$message.error(this.$t('allocationOrder.selectAuditStatusRequired'))
        return false
      }
      if (!this.formData.remark) {
        this.$message.error(this.$t('allocationOrder.inputReasonRequired'))
        return false
      }
      if (this.formData.remark.length > 200) {
        this.$message.error(this.$t('allocationOrder.reasonMaxLength'))
        return false
      }
      return true
    },
    submit() {
      if (!this.validateForm()) return
      
      if (this.callBackListener && this.callBackFunction) {
        this.$emit(this.callBackListener, this.callBackFunction, this.formData)
      }
      this.close()
    }
  }
}
</script>